module.exports = __webpack_public_path__ + "static/android_4_EN-95ba9baa4daedf28805a62a3b5e0c8a2.jpg";